import { createFileRoute } from "@tanstack/react-router"
import { useVariantContext } from "~/context/VariantProvider"
import { useMemo } from "react"
import { FinanceGraphCard } from "~/components/home/FinanceGraphCard"
import { FinanceSeries } from "~/constants/graphs"
import { useSkuStore } from "~/providers/sku-store-provider"
import { usePageTracking } from "~/hooks/usePageTracking"
import { AnalysisPage } from "~/components/design-system/pages"
import VariantInspector from "~/components/product/VariantInspector"

export const Route = createFileRoute("/_auth/product/$productId/_layout/finance")({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTracking("Product - Finance")

  const { variants, isMonthly, startDate, endDate } = useVariantContext()
  const variantIds = useMemo(() => variants.map((v) => v.variantId), [variants])

  const selectedWarehouseId = useSkuStore((state) => state.warehouseId)
  const selectedChannel = useSkuStore((state) => state.channel)

  return (
    <AnalysisPage inspector={<VariantInspector sections={["image", "details", "comments"]} />}>
      <div className="min-h-full flex flex-col gap-4">
        <FinanceGraphCard
          variantIds={variantIds}
          isMonthly={isMonthly}
          startDate={startDate}
          endDate={endDate}
          warehouseId={selectedWarehouseId}
          channel={selectedChannel}
          title="Gross Margin"
          graphHeight={200}
          series={[FinanceSeries.GrossMargin, FinanceSeries.FutureGrossMargin]}
        />
        <FinanceGraphCard
          variantIds={variantIds}
          isMonthly={isMonthly}
          startDate={startDate}
          endDate={endDate}
          warehouseId={selectedWarehouseId}
          channel={selectedChannel}
          title="Discount Percentage"
          graphHeight={200}
          series={[FinanceSeries.DiscountPercentage, FinanceSeries.FutureDiscountPercentage]}
          dataAsPercentage={true}
          showCurrency={false}
        />
        <FinanceGraphCard
          variantIds={variantIds}
          isMonthly={isMonthly}
          startDate={startDate}
          endDate={endDate}
          warehouseId={selectedWarehouseId}
          channel={selectedChannel}
          title="Revenue & Profit"
          graphHeight={200}
          series={[
            FinanceSeries.Profit,
            FinanceSeries.FutureProfit,

            FinanceSeries.Revenue,
            FinanceSeries.FutureRevenue,
          ]}
        />
        <FinanceGraphCard
          variantIds={variantIds}
          isMonthly={isMonthly}
          startDate={startDate}
          endDate={endDate}
          warehouseId={selectedWarehouseId}
          channel={selectedChannel}
          title="Revenue & Profit per item sold"
          graphHeight={200}
          series={[
            FinanceSeries.ItemProfit,
            FinanceSeries.FutureItemProfit,
            FinanceSeries.ItemPrice,
            FinanceSeries.FutureItemPrice,
          ]}
        />
      </div>
    </AnalysisPage>
  )
}
